<template>
  <div class="container">
    <div class="error">
      <img src="~@/assets/img/sorry404.svg" alt="404页面">
      <div class="back">
        <p>倒数<i>{{time}}s</i>自动回到首页</p>
        <router-link tag="button" to="/">马上回到首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      time: 10
    }
  },
  mounted () {
    this.computertime()
  },
  methods: {
    computertime () {
      let time
      time = setInterval(() => {
        if(this.time>0){
          this.time--
        }else{
          clearInterval(time)
          this.$router.push('/')
        }
      },1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  height 783px
.container .error
  width 1200px
  height 100%
  padding-top 20px
  margin-top 10px
  margin 0 auto
  position relative
.container .error img
  width 50%
  height 100%
  position absolute
  left 0%
.container .error .back
  position absolute
  right 20%
  top 40%
  color #5dbb9b
  font-size 26px
.container .error .back p i
  font-size 58px
  font-weight bold
  width 100px
  display inline-block
  text-align center
.container .error .back button
  padding 10px 20px
  background #5dbb9b
  color #fff
  margin-top 40px
  cursor pointer
  border-radius 30px
@media screen and (max-width: 768px)
  .container .error
    width 100%
  .container .error .back
    right 8%
@media screen and (max-width: 456px)
  .container
    height 10rem
    width 100%
  .container .error
    width 100%
  .container .error img
    top 0
    left 0
    height auto
    width auto
   .container .error .back
    position static
    margin-top 7.5rem
    text-align center
    font-size 20px
  .container .error .back button
    padding 5px 10px
    margin-top 20px
  .container .error .back p i
    font-size 26px
</style>



// WEBPACK FOOTER //
// src/Error/error.vue